import { connect } from 'react-redux';
import { AppState } from '../../app.state';
import { AddUserComponent } from './add-user.component';

export const AddUser = connect((sState: AppState) => ({ sState }))(
  AddUserComponent as any
) as unknown as typeof AddUserComponent;
